<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0"
  >
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-gray-800 text-xl font-bold">My account</h6>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <FormulateForm @submit="updateUser">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
          User Information
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="text"
                name="first_name"
                label="First name"
                validation="^required|min:2|max:50|matches:/^[a-zA-Z\s]+$/"
                validation-name="First name"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                v-model="currentUser.first_name"
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="text"
                name="middle_name"
                label="Middle name"
                validation="^required|min:2|max:50|matches:/^[a-zA-Z\s]+$/"
                validation-name="Middle name"
                outer-class="mb-4"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                v-model="currentUser.middle_name"
              />
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="text"
                name="last_name"
                label="Last name"
                validation="^required|min:2|max:50|matches:/^[a-zA-Z\s]+$/"
                validation-name="Last name"
                outer-class="mb-4"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                v-model="currentUser.last_name"
              />
            </div>
          </div>
          <div class="w-full lg:w-12/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="email"
                name="email"
                label="Email"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                disabled
                :value="currentUser.email"
                ignored
              />
            </div>
          </div>
        </div>

        <hr class="mt-6 border-b-1 border-gray-400" />

        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
          Contact Information
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
               <FormulateInput
                type="text"
                name="city"
                v-model="currentUser.city"
                placeholder="Sofia"
                validation="^optional|min:2|max:50|matches:/^[a-zA-Z\s]+$/"
                validation-name="City"
                label="City"
                outer-class="mb-4"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="text"
                name="country"
                v-model="currentUser.country"
                placeholder="Bulgaria"
                validation="^optional|min:2|max:50|matches:/^[a-zA-Z\s]+$/"
                validation-name="Country"
                label="Country"
                outer-class="mb-4"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
          </div>
        </div>

        <hr class="mt-6 border-b-1 border-gray-400" />

        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">About Me</h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-12/12 px-4">
            <div class="relative w-full mb-3">
              <FormulateInput
                type="textarea"
                name="description"
                v-model="currentUser.description"
                placeholder="Describe you as a person"
                validation="^optional|min:2|max:50"
                validation-name="Description"
                label="Description"
                outer-class="mb-4"
                input-class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
          </div>
        </div>
        <div class="w-full xl:w-12/12 xl:mb-0 px-3">
          <FormulateInput
            input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
            type="submit"
            name="Update"
          />
        </div>
      </FormulateForm>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardSettings
  Description: This class representing a cards with user settings.
*/

/* Imports */
import UserService from "@/services/user.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom user state values. 
  */
  data() {
    return {
        description: ""
    };
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call UserService class to update certain data on user.
    */
    updateUser(data) {
      UserService.updateUser(this.currentUser.id, data).then(() => {
        UserService.getUser(this.currentUser.id).then((response) => {
          localStorage.setItem("user", JSON.stringify(response));
          location.reload();
        });
      });
    },
  },

  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
